import React, { useState } from 'react';
import Dropzone from '../../components/Dropzone/Dropzone';
import Loading from '../../components/Loading';
import Text from '../../components/Text';
import stockApi from '../../services/StockApi';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import FormField from '../../components/Form/FormField';
import Helper from '../../services/Helper';

function SurplusMapping() {
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState(null);
    const [warnings, setWarnings] = useState(null);
    const [errors, setErrors] = useState(null);
    const [generalError, setGeneralError] = useState(null);
    const [cleanFile, setCleanFile] = useState(false);
    const [formError, setFormError] = useState("");
    const [barcodeUser, setBarcodeUser] = useState(false);
    const [validUser, setValidUser] = useState(false);

    const uploadFile = (file) => {
        setLoading(true);
        setCleanFile(false);
        setSuccessMessage(null);
        setGeneralError(null);
        let formData = new FormData();
        formData.append('file', file);

        const options = {
            headers: {
                'user-barcode': barcodeUser,
                'enctype': 'multipart/form-data'
            }
          };

        stockApi.post('/surplus-mapping', formData, options)
            .then(response => {
                if (response.data.success.length){
                    setSuccessMessage("IMPORTAÇÃO CONCLUÍDA COM SUCESSO");
                    setWarnings(response.data.warnings);
                    setErrors(response.data.errors);
                    setCleanFile(true);
                    setLoading(false);
                } else{
                    setWarnings(response.data.warnings);
                    setErrors(response.data.errors);
                    setLoading(false);
                }
            })
            .catch(error => {
                if(error.response?.data) {
                    setGeneralError(error.response?.data?.message);
                }
                else {
                    setGeneralError("Não foi possivel realizar o upload do arquivo para concluir o mapeamento, tente novamente");
                }
                setLoading(false);
            });
    }

    const onRemove = () => {
        setSuccessMessage(null);
        setWarnings(null);
        setErrors(null);
    }

    const handleChangeBarCodeUser = async (value) => {
      let isValid = await Helper.validateBarcodeUser(value).then((res) => {
          return res;
      });
      if (isValid) {
        setValidUser(true);
        setBarcodeUser(value);
      }
    }

    return (
        <>
          {
            loading ?
            <Loading loading={loading} style={{opacity: '0.7'}}/>
            : !validUser ?
            <>
              <Formik
                initialValues={{
                  userId: '',
                }}
                validationSchema={
                    Yup.object().shape({
                      userId: Yup.string()
                        .required('form.required')
                        .test('barcodeUser', 'receivement.form.error.barcodeUser', (values) => handleChangeBarCodeUser(values)),
                    })}
                validateOnChange={false}
                validateOnBlur={false}
                validateOnMount={true}
                onSubmit={() => {}}
              >
                {({
                  values, validateField, setTouched
                }) => (
                    <Form>
                      <FormField label="receivement.form.userId" name="userId" fieldType="password" onBlur={() => {validateField("userId"); setTouched(values)}} />
                    </Form>
                  )}
              </Formik>

              {formError &&
                <div><p style={{ color: 'red', marginTop: '20px', fontSize: '1.3em' }}>{formError}</p></div>}

            </>
            :
            <>
              <Text textType="header" style={{marginLeft: '50px', fontSize: '20px',fontWeight: '600'}} text="Mapeamento de Excedente" />

              <div style={{display: 'flex', marginTop: '25px', justifyContent: 'center', flexDirection: 'column'}}>
                  <Dropzone onUpload={(file)=> uploadFile(file)} types={['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']} clean={cleanFile} onRemove={onRemove} />
                  <p style={{fontSize: '18px', fontWeight: '500', color: '#DE3434', textAlign: "center"}}>{generalError}</p>
              </div>

              <div style={{display: 'flex', marginTop: '25px', marginLeft: '50px', justifyContent: 'center', flexFlow: 'column'}}>
                  {successMessage ?
                      <p style={{color: '#3baf12', width: '800px', fontSize: '18px', fontWeight: '500'}}>{successMessage}</p>
                  : null}

                  {errors && errors.length ?
                      <div style={{color: '#DE3434'}}>
                          <p style={{fontSize: '18px', fontWeight: '500'}}>Arquivo apresentou as seguintes inconsistências:</p>
                          <ul style={{marginLeft: '16px'}}>
                              {errors.map((error) => (
                                  <li style={{fontSize: '18px', fontWeight: '500'}}>{error}</li>
                              ))}
                          </ul>
                      </div>
                  : null}

                  {warnings && warnings.length ?
                      <div style={{color: '#b57900'}}>
                          <p style={{fontSize: '18px', fontWeight: '500'}}>== AVISOS ==</p>
                          <ul style={{marginLeft: '16px'}}>
                              {warnings.map((warning) => (
                                  <li style={{fontSize: '18px', fontWeight: '500', height: '25px'}}>{warning}</li>
                              ))}
                          </ul>
                      </div>
                  : null}
              </div>
            </>
            }
        </>
    )
}

export default SurplusMapping
